import { ExitIntent } from './index';

export enum ExitIntentTriggerMethod {
  idle,
  cursor,
}

export type ExitIntentTriggerPayload = {
  method: ExitIntentTriggerMethod;
  exitIntent: ExitIntent;
  target: Element;
};
